import { render } from "./SupportIssue.vue?vue&type=template&id=5b8cf2c8"
import script from "./SupportIssue.vue?vue&type=script&lang=js"
export * from "./SupportIssue.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__